<template>
  <component :is="page" />
</template>
<script>
  const profilePages = {
    Admin: () => import('./profile-admin'),
    Client: () => import('./profile-client'),
    ClientUser: () => import('./profile-client'),
    ClientOrderer: () => import('./profile-client'),
    Patient: () => import('./profile-patient')
  }

  export default {
    data() {
      return {
        page: profilePages[this.$auth.role]
      }
    }
  }
</script>